import { IS_EDITOR_WITHOUT_FOLDERS } from "@/api/user/editor";
import { createPoll as createPollService } from "@/utils/poll/create-poll-service";

export function ViewModel(params, element) {
  element.classList.add("fc-create-poll-link");

  const { isEditor } = params;

  const createPoll = (urlParams = {}, event) => {
    createPollService(isEditor, urlParams, event);
  };

  return {
    editorWithoutFolders: IS_EDITOR_WITHOUT_FOLDERS,
    createPoll,
  };
}
